module.exports = __webpack_public_path__ + "static/img/fullscreen-image_or-add-your-own_768.9bedc2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_or-add-your-own_768.png
// module id = mm9S
// module chunks = 0